// Centralized label mappings for enumerated or coded demographic fields
// Add new mappings here and use getLabel(mapping, key) to safely retrieve.

export const householdIncomeLabels = {
  under_25k: 'Under $25,000',
  '25k_49k': '$25,000 - $49,999',
  '50k_74k': '$50,000 - $74,999',
  '75k_99k': '$75,000 - $99,999',
  '100k_149k': '$100,000 - $149,999',
  '150k_199k': '$150,000 - $199,999',
  '200k_plus': '$200,000+',
  decline: 'Prefer not to say'
};

export const insuranceCoverageLabels = {
  uninsured: 'No Insurance',
  medicaid: 'Medicaid',
  medicare: 'Medicare',
  marketplace: 'Marketplace / ACA Plan',
  private: 'Private Insurance',
  insuredThroughEmployer: 'Employer Provided',
  va: 'VA / Military',
  other: 'Other',
  decline: 'Prefer not to say'
};

export function getLabel(mapping, raw) {
  if (!raw) return null;
  const key = String(raw).trim();
  return mapping[key] || startCaseFromKey(key);
}

// Fallback to transform snake_case or camelCase to Start Case
function startCaseFromKey(key) {
  return key
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^\w|\s\w/g, c => c.toUpperCase());
}
